import { useState } from "react";
import SectionHeading from "./SectionHeading";
import { scenarios } from "@/mocks/home";

export default function ScenarioCompare() {
  const [active, setActive] = useState(scenarios[0].key);
  const current = scenarios.find((item) => item.key === active) ?? scenarios[0];

  const rows = [
    { label: "舞台设定", value: current.setting, icon: "ri-movie-2-line" },
    { label: "主要空间", value: current.space, icon: "ri-map-pin-2-line" },
    { label: "关系结构", value: current.relation, icon: "ri-links-line" },
    { label: "叙事节奏", value: current.rhythm, icon: "ri-time-line" },
    { label: "核心焦点", value: current.focus, icon: "ri-focus-3-line" },
  ];

  return (
    <section id="compare" className="section-anchor bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          eyebrow="SCENARIO COMPARISON"
          title="四种关系场景横向对比"
          desc="家教、私教、补习、辅导看似都在“上课”，但空间、关系结构与节奏完全不同，切换到不同场景即可看到差异。"
        />

        <div className="mt-8 md:mt-10 flex flex-wrap gap-2 p-1.5 rounded-full bg-background-50 border border-background-200 w-fit max-w-full">
          {scenarios.map((item) => (
            <button
              key={item.key}
              type="button"
              onClick={() => setActive(item.key)}
              className={`inline-flex items-center gap-2 px-4 py-2 rounded-full font-label text-sm whitespace-nowrap transition-colors ${
                active === item.key
                  ? "bg-primary-500 text-background-50"
                  : "text-foreground-700 hover:bg-primary-100/70"
              }`}
            >
              <i className={item.icon} />
              {item.name}
            </button>
          ))}
        </div>

        <div className="mt-8 grid grid-cols-1 lg:grid-cols-12 gap-6">
          <div className="lg:col-span-5 rounded-lg border border-background-200 bg-background-50 p-6 md:p-7">
            <span className="font-label text-xs tracking-[0.3em] text-accent-600">
              {current.en.toUpperCase()}
            </span>
            <div className="mt-3 flex items-center gap-3">
              <span className="w-12 h-12 rounded-lg flex items-center justify-center bg-accent-500/15 text-accent-700">
                <i className={`${current.icon} text-2xl`} />
              </span>
              <h3 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
                {current.name}
              </h3>
            </div>
            <p className="mt-5 text-sm md:text-base leading-7 text-foreground-700">
              {current.setting}
            </p>
            <div className="mt-6 flex flex-wrap gap-2">
              {current.tags.map((tag) => (
                <span
                  key={tag}
                  className="px-3 py-1 rounded-full bg-secondary-100 text-secondary-900 font-label text-xs"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>

          <div className="lg:col-span-7 rounded-lg border border-background-200 bg-background-50 p-6 md:p-7">
            <ul className="space-y-1">
              {rows.map((row) => (
                <li
                  key={row.label}
                  className="flex flex-col sm:flex-row sm:items-start gap-1 sm:gap-4 py-3 border-b border-background-200 last:border-b-0"
                >
                  <span className="flex items-center gap-2 sm:w-32 shrink-0 font-label text-sm text-foreground-500">
                    <i className={`${row.icon} text-primary-600`} />
                    {row.label}
                  </span>
                  <span className="text-sm md:text-base text-foreground-900 leading-7">
                    {row.value}
                  </span>
                </li>
              ))}
            </ul>

            <div className="mt-6 rounded-lg bg-background-100/80 border border-background-200 p-4 md:p-5">
              <h4 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
                <i className="ri-node-tree text-accent-600" />
                典型推进节点
              </h4>
              <ol className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-3">
                {current.beats.map((beat, index) => (
                  <li
                    key={beat}
                    className="flex items-start gap-3 text-sm text-foreground-700"
                  >
                    <span className="w-6 h-6 shrink-0 rounded-full flex items-center justify-center bg-secondary-500 text-background-50 font-label text-xs">
                      {index + 1}
                    </span>
                    <span className="leading-6">{beat}</span>
                  </li>
                ))}
              </ol>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}